import pluriLogo from "./../../image/logo.png";

function UnderConstruction() {
  return (
    <article>
      <p>Under Construction</p>
    </article>
  );
}

export default UnderConstruction;
